const basico1 = {
  titulo: `JavaScript: variables y salidas con console.log`,
  problemas: [
    {
      codigo: 1,
      descripcion: `Una variable es un depósito donde hay un valor. Consta de un nombre y pertenece a un tipo: numeric, string, boolean etc.
Utilizamos la palabra clave let para definir una variable y el operador de asignación si queremos cargar un valor inmediatamente:
<code>      
let nombre = "Juan"
let edad = 50
</code>
Las variables son nombres que ponemos a los lugares donde almacenamos la información.
En JavaScript, deben comenzar por una letra, pudiendo haber además dígitos luego de la primer posición. Una variable no puede tener el mismo nombre de una  palabra clave del lenguaje.
El lenguaje JavaScript es sensible a mayúsculas y minúsculas, es decir que las variables edad y EDAD son distintas:
<code>
let edad = 50
let EDAD = 10
</code>
Las palabras claves del lenguaje deben escribirse siempre con minúsculas: let, if, while etc.
Para hacer salidas por pantalla utilizaremos el objeto console.log() y dentro de él escribiremos el valor que queremos mostrar. Esta herramienta nos permite escribir código que nos ayuda a verificar si nuestros algoritmos son correctos.
Problema: Hallar la superficie de un cuadrado de lado 4.
Debe cargar en el cuadro de entrada el número 16 que es el resultado de multiplicar la variable lado por si misma.
`,
      programa: `let lado = 4
let superficie = lado * lado
console.log(superficie)`,
      solucion: "16"
    },{
      codigo: 2,
      descripcion: `Si definimos una variable por ejemplo en minúsculas y luego tratamos de accederla con mayúsculas, nos dará error (ingrese el texto error en la salida del siguiente problema)`,
      programa: `let lado = 4
let superficie = lado * lado
console.log(SUPERFICIE)`,
      solucion: "error"
    },{
      codigo: 3,
      descripcion: `Inclusive si hay un solo caracter erróneo en el nombre de la variable, nos dará error`,
      programa: `let lado = 4
let superficie = lado * lado
console.log(Superficie)`,
      solucion: "error"
    },{
      codigo: 4,
      descripcion: `Las palabras claves del lenguaje también deben estar en minúsculas, es otro tipo de error que se nos presentará al principio cuando estamos aprendiendo a programar.`,
      programa: `Let lado = 4
let superficie = lado * lado
console.log(superficie)`,
      solucion: "error"
    },{
      codigo: 5,
      descripcion: `Por el momento vamos a decir que el método log del objeto console nos permite hacer salidas por pantalla y controlar el resultado de nuestros algoritmos (también debemos respetar que su escritura sea en minúsculas)`,
      programa: `Let lado = 4
let superficie = lado * lado
CONSOLE.log(superficie)`,
      solucion: "error"
    },{
      codigo: 6,
      descripcion: `Si necesitamos almacenar un valor que no va a cambiar durante la ejecución del programa, podemos usar la palabra clave const.`,
      programa: `const pi = 3.14
let medida = 2 * pi
console.log(medida)`,
      solucion: "6.28"
    },{
      codigo: 7,
      descripcion: `Lo que si hay que tener en cuenta que si utilizamos la palabra clave const, no podemos volver a cambiar el valor (estamos definiendo una constante), si queremos cambiar el valor, debemos usar la palabra clave let. Si intentamos cambiar el valor de una constante, nos dará error.`,
      programa: `const pi = 3.14
pi = 3.1415      
let medida = 2 * pi
console.log(medida)`,
      solucion: "error"
    },{
      codigo: 8,
      descripcion: `Hay dos tipos de errores que se nos pueden presentar cuando codificamos nuestro código: 
<code>- errores de sintaxis.
- errores lógicos.</code>
A los errores tipográficos, como por ejemplo indicar el nombre incorrecto de un método (Log en lugar de log), nombres de objetos incorrectos (Console en lugar de console), nombres de variables incorrectas, falta de paréntesis, palabras claves mal escritas, etc. los llamamos errores <strong>sintácticos</strong>:`,
      programa: `CONST impuesto = 21
Console.Log(impuesto)`,
      solucion: "error"
    },{
      codigo: 9,
      descripcion: `Existe otro tipo de errores llamados <strong>errores lógicos</strong>. Este tipo de errores en programas grandes (miles de líneas) son más difíciles de localizar. Por ejemplo un programa que permite hacer la facturación pero la salida de datos por impresora es incorrecta. Otra situación muy sencilla es si queremos sumar dos variables pero utilizamos el operador menos:`,
      programa: `let valor1 = 10
let valor2 = 20
let suma = valor1 - valor2
console.log(suma)`,
      solucion: "-10"
    },{
      codigo: 10,
      descripcion: `El lenguaje JavaScript no requiere obligatoriamente puntos y comas en cada línea del programa, más alla que muchos programadores los disponen.`,
      programa: `let base = 10;
let altura = 20;
let area = base * altura;
console.log(area)`,
      solucion: "200"
    },{
      codigo: 11,
      descripcion: `Algo muy importante es que si una variable no se la inicializa y consultamos el valor almacenado, nos dará el valor undefined.`,
      programa: `let base
console.log(base)`,
      solucion: "undefined"
    },{
      codigo: 12,
      descripcion: `Más drástico es si definimos una constante sin inicializarla, nos dará error.`,
      programa: `const pi
console.log(pi)`,
      solucion: "error"
    }
  ]
}

export default basico1;